import React from "react";

export default function Seo(props) {
  return (
    <>
      <title>{props.title}</title>
      <link rel="canonical" href={props.url + "/"} />
      <meta name="description" content={props.description} />

      <meta name="og:url" content={props.url} />
      <meta name="og:type" content="website" />

      <meta
        name="og:image"
        content={"https://royalflowersgroup.com/opengraph-image.jpg"}
      />

      <meta name="og:title" content={props.title} />
      <meta name="og:description" content={props.description} />

      {props.schema && (
        <script type="application/ld+json">
          {JSON.stringify(props.schema)}
        </script>
      )}

      {props.children}
    </>
  );
}
